// extracted by mini-css-extract-plugin
export default {"Instructions":"Instructions_Instructions__SXZSc"};